export const CANNOT_REACH_BACKEND_PATH = '/cannot-reach-backend';
export const CANNOT_REACH_BACKEND_RETURN_URL_QUERY_PARAM = 'returnUrl';

interface LocationParts {
  pathname: string;
  search: string;
  hash: string;
}

export function buildCannotReachBackendUrl(location: LocationParts): string {
  const returnUrl = resolveCannotReachBackendRetryUrl(
    `${location.pathname}${location.search}${location.hash}`
  );
  const params = new URLSearchParams({
    [CANNOT_REACH_BACKEND_RETURN_URL_QUERY_PARAM]: returnUrl,
  });

  return `${CANNOT_REACH_BACKEND_PATH}?${params.toString()}`;
}

export function resolveCannotReachBackendRetryUrl(returnUrl: string | null | undefined): string {
  if (!returnUrl || !returnUrl.startsWith('/') || returnUrl.startsWith('//')) {
    return '/';
  }

  const path = extractPath(returnUrl);
  if (path === CANNOT_REACH_BACKEND_PATH || path.startsWith(`${CANNOT_REACH_BACKEND_PATH}/`)) {
    return '/';
  }

  return returnUrl;
}

function extractPath(url: string): string {
  const suffixStart = url.search(/[?#]/);
  return suffixStart === -1 ? url : url.slice(0, suffixStart);
}
